import React, { useEffect } from 'react';
import setSeo from '../utils/seo.js';
import Hero from '../components/Hero.jsx';
import EmpathyScrollStory from '../components/EmpathyScrollStory.jsx';
import BreakFree from '../components/BreakFree.jsx';
import Package from '../components/Package.jsx';
import Value from '../components/Value.jsx';
import Experience from '../components/Experience.jsx';
import Testimonials from '../components/Testimonials.jsx';
import SaveTime from '../components/SaveTime.jsx';

/**
 * Home page aggregates all primary sections of the site. It reuses the Hero
 * component for the landing area and then stacks the about, features, value,
 * testimonials and contact sections. Additional pages (Solutions, Blog,
 * Case Studies) are accessible via the navigation bar.
 */
const Home = () => {
  useEffect(() => {
    setSeo({
      title: 'Aakeeo Technologies | CRM Consulting & AI Workflow Automation',
      description:
        'Aakeeo Technologies delivers expert CRM consulting, SuiteCRM customization, and AI workflow automation to streamline your operations and boost customer engagement. Transform your business with our cutting-edge solutions.',
      keywords: ['CRM consulting', 'SuiteCRM', 'AI automation', 'workflow automation', 'business automation', 'CRM implementation', 'customer engagement'],
      canonical: window.location.href,
      og: {
        title: 'Aakeeo Technologies | CRM & AI Automation Experts',
        description: 'Transform your business with expert CRM consulting, SuiteCRM customization, and AI workflow automation. Streamline operations and boost customer engagement.',
        type: 'website'
      },
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': 'Aakeeo Technologies',
        'url': 'https://aakeeo.com',
        'logo': 'https://aakeeo.com/Aakeeo_favicon.png',
        'description': 'Expert CRM consulting, SuiteCRM customization, and AI workflow automation services.',
        'address': {
          '@type': 'PostalAddress',
          'addressCountry': 'US'
        },
        'sameAs': [
          'https://twitter.com/aakeeo',
          'https://www.linkedin.com/company/aakeeo'
        ],
        'contactPoint': {
          '@type': 'ContactPoint',
          'contactType': 'Sales',
          'url': 'https://aakeeo.com/contact'
        }
      }
    });
  }, []);

  return (
    <main>
      <Hero />
      <EmpathyScrollStory />
      <BreakFree />
      <Package />
      <Value />
      <Experience />
      <Testimonials />
      <SaveTime />
    </main>
  );
};

export default Home;